import React, { useEffect } from "react"
import { Dimensions } from "react-native"

import {
  WindowDimensionsStore,
  WindowDimensions,
  WindowDimensionsEvent,
} from "./store"

export type { WindowDimensions }
export { WindowDimensionsEvent }

function getWindowDimensions() {
  return {
    width: Dimensions.get("window").width,
    height: window.innerHeight,
  }
}

export const windowDimensionsStore = new WindowDimensionsStore(
  getWindowDimensions(),
)

export function WindowDimensionsProvider({
  children,
}: {
  children: React.ReactNode
}) {
  useEffect(() => {
    const sub = Dimensions.addEventListener("change", (event) =>
      windowDimensionsStore.set(event.window),
    )
    return () => sub.remove()
  }, [])

  return children
}
